import { Grid, Typography, Box } from "@mui/material";
import styles from './index.module.css';
import { formatCalendarDateLong } from '../../../utils/common';

const Address = ({ label, name, address }) => (
  <div className={styles.printAddressBlock}>
    <div className={styles.printSectionLabel}>{label}</div>
    <div>{name && <>{name}<br /></>}{address || 'N/A'}</div>
  </div>
);
const MetaField = ({ label, children, className = '' }) => (
  <div className={`${styles.printMetaField} ${className}`}>
    <span className={styles.printMetaLabel}>{label}</span>
    <span className={styles.printMetaValue}>{children}</span>
  </div>
);

const EstimationDetails = ({ estimationDetails, isEstimateView = false, showScreen = true }) => {
  const project = estimationDetails?.estimationId || '';
  const documentNumberLabel = isEstimateView ? 'ESTIMATE #' : 'SALES ORDER #';
  // Sales Order dates are calendar dates, not instants to convert into the
  // viewer's timezone (UTC midnight would show as the previous day in Alberta).
  // Reuse the same date-only interpretation as the generated document header.
  const orderDate = formatCalendarDateLong(estimationDetails?.orderDate) || 'N/A';
  const inHandsDate = formatCalendarDateLong(estimationDetails?.inhandsDate) || 'N/A';

  return <>
    {showScreen && <Grid container className={`${styles.headerContainer} ${styles.screenOnly}`}>
      <Grid item xs={6} className={styles.addressContainer}><Grid container spacing={2} className={styles.addressGrid}>
        <Grid item xs={6} className={styles.addressGridItem}><Box><Typography variant="h6" gutterBottom>Billing Address</Typography><Typography variant="body1">{estimationDetails?.billingName}</Typography><Typography sx={{ whiteSpace: 'pre-line' }} variant="body1">{estimationDetails?.billingAddress || 'N/A'}</Typography></Box></Grid>
        <Grid item xs={6} className={styles.addressGridItem}><Box><Typography variant="h6" gutterBottom>Shipping Address</Typography><Typography variant="body1">{estimationDetails?.shippingName}</Typography><Typography sx={{ whiteSpace: 'pre-line' }} variant="body1">{estimationDetails?.shippingAddress || 'N/A'}</Typography></Box></Grid>
      </Grid></Grid>
      <Grid item xs={5} className={styles.TitleContainer}>
        <Box className={styles.titleValueContainer}><Box><Typography variant="body1" className={styles.title} gutterBottom>{documentNumberLabel}</Typography><Typography variant="body1" className={styles.value}>{project || 'N/A'}</Typography></Box><Box><Typography className={styles.title} gutterBottom>ORDER DATE</Typography><Typography className={styles.value}>{orderDate}</Typography></Box><Box><Typography className={styles.title} gutterBottom>IN HANDS DATE</Typography><Typography className={styles.value}>{inHandsDate}</Typography></Box></Box>
        <Box className={styles.titleValueContainer}><Box><Typography className={styles.title} gutterBottom>TERMS</Typography><Typography className={styles.value}>{estimationDetails?.term?.title || 'N/A'}</Typography></Box>{estimationDetails?.customerPo && <Box><Typography className={styles.title} gutterBottom>CUSTOMER PO</Typography><Typography className={styles.value}>{estimationDetails.customerPo}</Typography></Box>}<Box><Typography className={styles.title} gutterBottom>CURRENCY CODE</Typography><Typography className={styles.value}>{estimationDetails?.currency || 'N/A'}</Typography></Box></Box>
      </Grid>
    </Grid>}
    <section className={`${styles.printOnly} ${showScreen ? styles.manualScreenAvailable : ""}`}>
      <div className={styles.printHeaderDetails}>
        <div className={styles.printAddressSection}>
          <Address label="Billing Address" name={estimationDetails?.billingName} address={estimationDetails?.billingAddress} />
          <Address label="Shipping Address" name={estimationDetails?.shippingName} address={estimationDetails?.shippingAddress} />
        </div>
        <div className={styles.printMetadataSection}>
          <div className={styles.printMetadataTopRow}>
            <MetaField label={documentNumberLabel}>{project || 'N/A'}</MetaField><MetaField label="Order Date">{orderDate}</MetaField><MetaField label="In Hands Date">{inHandsDate}</MetaField>
          </div>
          <div className={styles.printMetadataBottomRow}>
            <MetaField label="Terms" className={styles.printTermsField}>{estimationDetails?.term?.title || 'N/A'}</MetaField><MetaField label="Currency">{estimationDetails?.currency || 'N/A'}</MetaField>
          </div>
        </div>
      </div>
    </section>
  </>;
};
export default EstimationDetails;
